import { render, staticRenderFns } from "./RemediationStatusBoard.vue?vue&type=template&id=bd952ace&scoped=true"
import script from "./RemediationStatusBoard.vue?vue&type=script&lang=js"
export * from "./RemediationStatusBoard.vue?vue&type=script&lang=js"
import style0 from "./RemediationStatusBoard.vue?vue&type=style&index=0&id=bd952ace&prod&scoped=true&lang=css"
import style1 from "./RemediationStatusBoard.vue?vue&type=style&index=1&id=bd952ace&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd952ace",
  null
  
)

export default component.exports